import React, { Component } from 'react';
import { oyoFormView, borders, validation } from '../../../Enums';
import OtpComponent from './OtpComponent';
import HomeStepTwoWidget from './HomeStepTwoWidget';
import {
  hasNumber,
  hasSpecialCharacter,
  hasUpperCase,
  isNumber
} from '../../../utils/functionUtils';
import BackIcon from '../../../resources/vectors/BackIcon';
import { path } from '../../../utils';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutline from '@material-ui/icons/HelpOutline';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';

class SignUpScreenWidget extends Component {
  constructor(props) {
    super(props);
    this.changeOtp = this.changeOtp.bind(this);
    this.signUp = this.signUp.bind(this);
    this.validatePwd = this.validatePwd.bind(this);
  }

  state = {
    email_border: borders.NORMAL_BORDER,
    password_border: borders.NORMAL_BORDER,
    confirm_password_border: borders.NORMAL_BORDER,
    password_validated: true,
    confirm_password_validated: true,
    password: '',
    cnfm_password: '',
    otp: null,
    showToolTip: false,
    pwd_hidden : true
  };

  signUp = () => {
    /* I am calling this function from parent because
     APIs need to be called from a place from where everything can be controlled.
     I am doing this so that I can manage the sign up and validation logic within this component
     .Also, I don't want to put the password in the reducer or props */
    let emailValid = this.props.validateOneField(validation.HOTEL_EMAIL);
    let passwordValid = this.validatePwd();

    let otpInfoAvailable = this.checkOtpInfo();
    if (emailValid && passwordValid && otpInfoAvailable) {
      // required:  otp, phone, country_code, email, password
      let signUpData = {
        otp: this.state.otp,
        phone: this.props.globalData.formData.mobile_number,
        country_code: this.props.globalData.formData.dial_code,
        email: this.props.globalData.formData.email_address,
        password: this.state.password,
        name:this.props.globalData.formData.full_name,
        room_count: path(this.props.globalData, 'number_of_rooms'),
        city_id: path(this.props.globalData, 'selected_location.city.id'),
        country_id: path(this.props.globalData, 'selected_location.country.id'),
        sub_source_code: this.props.utm_data
      };
      this.props.globalActions.postSignUp(signUpData);
    }
  };

  validatePwd = () => {
    let pwd = this.state.password;
    let message;
    if (pwd.length < 6) {
        message = 'Password must contain at least 6 characters';
    } else if (!hasUpperCase(pwd)) {
        message = 'Password must contain at least 1 capital letter';
    } else if (!hasNumber(pwd)) {
        message = 'Password must contain at least 1 number';
    } else if (!hasSpecialCharacter(pwd)) {
        message = 'Password must contain at least 1 special character';
    } else if (!(pwd == this.state.cnfm_password)) {
        message = 'Password confirmation failed. Please enter the same password.';
        this.props.globalActions.errorSignUp({ message });
        this.setState({ confirm_password_validated: false });
        this.setState({ password_validated: true });
        return false;
    }

    if (message) {
      this.setState({ password_validated: false,confirm_password_validated:true });
      this.props.globalActions.errorSignUp({ message });
      return false;
    }else{
        this.setState({ password_validated: true,confirm_password_validated:true });
        this.props.globalActions.errorSignUp('');
    }

    this.setState({
      password_validated: true,
      confirm_password_validated: true
    });
    return true;
  };

  checkOtpInfo = () => {
    let otpData = this.props.globalData.otpData;
    if (path(otpData,"data.status",false))
      return true;
    return false;
  };

  componentDidMount() {
      this.props.setSignUpFunction(this.signUp);
  }

  changeOtp = otp => {
    if (isNumber(otp)) this.setState({ otp: otp });
  };

  changePwd = e => {
    this.setState({ password: e.target.value }, () => {
      if (!this.state.password_validated) {
        this.validatePwd();
      }
    });
  };

  changeCnfmPwd = e => {
      this.setState({ cnfm_password: e.target.value },() => {
          if (!this.state.confirm_password_validated) {
              this.validatePwd();
          }
      });
  };
  
  toggleShow = () => {
    this.setState({pwd_hidden : !this.state.pwd_hidden});
  };

  render() {
    let gs = this.props.gs;
    let gc = this.props.gc;
    let guc = this.props.guc;

    return (
      <div>
        <BackIcon className={'hover'} onClick={() => {
          this.props.changeFormScreen(oyoFormView.otpScreen);
        }} style={gs('back')}/><div style={gs('big_text_form')}>{guc('get_associated')}</div>

        <div style={{ ...gs('form_small_text'),marginTop:'4px' }}>
          {guc('veri_code_otp_sent')}
        </div>

        <OtpComponent
          gc={gc}
          gs={gs}
          guc={guc}
          otp={this.state.otp}
          changeOtp={this.changeOtp}
          globalData={this.props.globalData}
        />

        <div
          className={'hover'}
          onClick={this.props.regenerateOtp}
          style={{
            ...gs('form_small_text'),
            color: 'blue',
            textDecoration: 'underline',
            marginBottom:'8px',
            width:'fit-content'
          }}
        >
          {gc('regenerate_otp')}
        </div>

        <div style={gs('form_small_text')}>{guc('your_email') + '*'}</div>
        <input
          placeholder={''}
          type="text"
          autoComplete="new-password"
          onChange={e => {
            if (!this.props.email_border_validated) {
              this.props.validateOneField(validation.HOTEL_EMAIL);
            }
            this.props.globalActions.dataUpdate(
              'email_address',
              e.target.value
            );
          }}
          value={this.props.globalData.formData.email_address}
          className={'removeFocusOutline'}
          style={{
            ...gs('input_form'),
            border: this.props.email_border_validated
              ? this.state.email_border
              : borders.RED_BORDER
          }}
          onFocus={() => {
            this.setState({
              email_border: borders.ACTIVE_BORDER
            });
          }}
          onBlur={() => {
            this.setState({
              email_border: borders.NORMAL_BORDER
            });
          }}
        />

        <div style={gs('form_small_text')}>{gc('Password')}{'*'}</div>
        <div style={gs('pwd_container')}>
        <input
          placeholder={gc('password_placeholder')}
          type="password"
          autoComplete="new-password"
          onChange={this.changePwd}
          value={this.state.password}
          className={'removeFocusOutline'}
          style={{
            ...gs('input_form'),
            width : '88%',
            paddingRight : '27px',
            border: this.state.password_validated
              ? this.state.password_border
              : borders.RED_BORDER
          }}
          onFocus={() => {
            this.setState({
              password_border: borders.ACTIVE_BORDER
            });
          }}
          onBlur={() => {
            this.setState({
              password_border: borders.NORMAL_BORDER
            });
          }}
        />
        <span style={{    position: 'absolute', right: '7px', top: '13px'}}>
        <ClickAwayListener
            onClickAway={() => this.setState({ showToolTip: false })}
        >
          <Tooltip
              open={this.state.showToolTip}
              onClick={() => this.setState({ showToolTip: true })}
              className={'hover pointerEvents'}
              title={<div style={{pointerEvents:'all'}}>{gc('password_must_contain')}</div>}
          >
            <HelpOutline style={gs('help_revenue')} />
          </Tooltip>
        </ClickAwayListener>
        </span>
        </div>

        <div style={gs('form_small_text')}>{gc('confirm_password')}{'*'}</div>
        <div style={gs('pwd_container')}>
        <input
          placeholder={gc('password_placeholder')}
          type={  this.state.pwd_hidden ? "password"  : "text"  }
          autoComplete="new-password"
          onChange={this.changeCnfmPwd}
          value={this.state.cnfm_password}
          className={'removeFocusOutline'}
          style={{
            ...gs('input_form'),
            width : '88%',
            paddingRight : '27px',
            border: this.state.confirm_password_validated
              ? this.state.confirm_password_border
              : borders.RED_BORDER
          }}
          onFocus={() => {
            this.setState({
              confirm_password_border: borders.ACTIVE_BORDER
            });
          }}
          onBlur={() => {
            this.setState({
              confirm_password_border: borders.NORMAL_BORDER
            });
          }}
        />
          <span style={{    position: 'absolute', right: '7px', top: '13px'}}>
            {this.state.pwd_hidden ?
                <VisibilityOffOutlinedIcon onClick={this.toggleShow}/>
                :<VisibilityOutlinedIcon onClick={this.toggleShow}/>
            }
          </span>
        </div>

        {this.props.globalData.signUpData.errorMessage && (
          <div
            style={{ ...gs('form_small_text'), color: 'red', lineHeight: '1',marginTop:'3px' }}
          >
            {this.props.globalData.signUpData.errorMessage}
          </div>
        )}
      </div>
    );
  }
}

export default SignUpScreenWidget;
